import { extend } from "vee-validate";

extend("positive", value => {
  if (value >= 0) return true;

  return "Must be a positive number";
});
